export const columns = [
  {
    Header: "Estado",
    accessor: "state",
    filterable: true,
    filterMethod: (filter, row) => (row.state ?? '').toLowerCase().includes(filter.value.toLowerCase())
  },
  {
    Header: "Municipio",
    accessor: "name",
    filterable: true,
    filterMethod: (filter, row) => (row.name ?? '').toLowerCase().includes(filter.value.toLowerCase())
  }
];